export enum WorkflowAction {
  TE = "TE",
  ACTION = "Action",
}

export const MARK_HIGH_PRIORITY_WORKFLOW = "Mark High Priority";

export interface DocumentMapping {
  accountId: string | null;
  accountLastName: string | null;
  accountFirstName: string | null;
  classification: string;
  displayName: string;
  assignedTo: string | null;
  /** ModMed queue the CC automation falls back to when `assignedTo` doesn't resolve; defaults to the group's generic fallback assignee when unset. */
  secondaryAssignedTo?: string | null;
  /** Resolved provider's EHR provider ID written to an EHR document index field (e.g. NextGen's "Provider Name") on upload, independent of `assignedTo` — for EHR-native routing with no internal task. */
  uploadProviderId?: string | null;
  folder: string | null;
  markAsReviewed?: boolean | null;
  /** Config routing subdomain (`ConfigSubdomain`), not display name. */
  group: string;
  workflowType: string;
  priority?: string | null;
  inputDate: string;
  documentLabel: string;
  documentTypeId?: number | null;
  internalNote?: string | null;
  instructions: readonly string[] | null;
  workflowAction: WorkflowAction | null;
  additionalWorkflow: readonly string[] | null;
  folderMapping: string | null;
  teMessage?: string | null;
}

export type DynamicDocumentInstructions = DocumentMapping & {
  tags?: readonly string[] | null;
  note?: string | null;
  noteLabel?: string | null;
  statusLine?: string | null;
  showMatchedOrderingProvider?: boolean;
};

export type DocumentMappingRegistry = Record<string, DocumentMapping>;
